import { render } from "./OutletCategoryPage.vue?vue&type=template&id=796765f9&lang=pug"
import script from "./OutletCategoryPage.vue?vue&type=script&lang=js"
export * from "./OutletCategoryPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__